import { cn } from '@/shared/utils/cn';

/** Caja y campo interior compartidos por Input, Textarea y NumberField (borde 3:1, anillo de foco en la caja). */
export const fieldBoxClass = cn(
  'flex w-full items-center gap-2 rounded-md border border-input bg-card px-3 text-fg',
  'transition-[border-color,box-shadow] duration-fast ease-standard',
  'focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-ring',
  'data-[disabled=true]:cursor-not-allowed data-[invalid=true]:border-down data-[disabled=true]:bg-muted data-[disabled=true]:opacity-60',
);

export const fieldInnerClass = cn(
  'min-w-0 flex-1 bg-transparent text-base text-fg outline-none focus-visible:outline-none',
  'placeholder:text-fg-muted disabled:cursor-not-allowed',
);
